import templateUrl from 'emun.salesrep/territory-manager/repgroup/repgroup-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class RepGroupListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryRepGroups.json',
			autoLoad: true,
			hideLeftNav: true
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("repgroupSaved", () => $ctrl.query.load(true));
    }
	create() {
		const $ctrl = this;
		modals.prompt('Rep Group Name...').result.then(name => {
			$ctrl.bus.send("CreateRepGroup.json", {
				id: name,
				name: name 
			})
			.then(function () {
				$ctrl.$state.transitionTo("repgroup", { repgroupId: name });
			});
		});
	}
	
	delete(repgroup) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + repgroup.name, "Delete Rep Group?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRepGroup.json", repgroup)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let RepGroupList = {
	controller: RepGroupListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default RepGroupList;
